<template>
  <div >


    <!--<div style="position: relative; z-index: -1" width="100%">-->
      <!--<v-img src="../assets/images/content/math.png"  ></v-img>-->
    <!--</div>-->

    <Section background="white"  class="image-bg"
             :style="{'background-image': `url(${require('../assets/images/content/shutterstock_655688416-web.png')})`}"
    >

      <div class="bg-transparent-light">
        <nav-bar></nav-bar>
        <div class=" main-heading heading-line">


          <v-container>
            <v-row justify="center">
              <v-col cols="12" justify="start">
                <div class="center display-1">Better Living Endoscopy Center</div>
                <div class="center title">Gastroenterology and Internal Medicine</div>


                <!--<v-btn x-large to="/contact" color="accent" class="text&#45;&#45;primary mt-9" >Request Appointment</v-btn>-->
                <div class="pt-9" :class="heading_text">
                  Conditions
                </div>

              </v-col>

            </v-row>
          </v-container>
        </div>


        <!--services menu items-->
        <v-container>
          <v-row :class="menu_text" justify="center">

            <v-col v-for="(item, i) in pages" :key="i" align="center" shrink>
            <!--<span class="heading-hover" :class="highlight_class(i)" @click="page_index = i">-->
              <!--{{item}}-->
            <!--</span>-->

              <span  :class="highlight_class(i)" @click="page_index = i">
                  <router-link :to="item.link" class="heading-hover">{{item.title}}</router-link>
            </span>


            </v-col>


          </v-row>
        </v-container>
      </div>




    </Section>









    <Section background="white" >

      <v-container class="content-container">
        <v-row justify="center" class="pl-3 pr-3">

          <reflux v-if="page_index===0"></reflux>
          <colon-cancer v-if="page_index===1"></colon-cancer>
          <constipation v-if="page_index===2"></constipation>
          <nausea v-if="page_index===3"></nausea>
          <rectal-bleeding v-if="page_index===4"></rectal-bleeding>

        </v-row>

      </v-container>

    </Section>

















  </div>

</template>






<style scoped lang="scss">


  .image-bg{
    background-size: cover;
    background-position: center;
  }

  .main-heading{
    height: 250px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    /*background-image: url('../assets/images/content/math.png')*/

    background-size: cover;
    /*background-size: auto 100%;*/
    /*background-size: 100% auto;*/
    background-position: center;
    text-align: center;
    }


  .heading-line{

    font-size: 2em;

  }


  .bg-transparent-light{
    background: rgba(255, 255, 255, 0.9);
    width:100%;
    height: 100%;


  }


  li{
    padding-bottom: 5px;
  }


  .heading-highlight{
    text-shadow: 2px 2px 4px #656565;
  }


  .heading-hover{
    color: #5e5e5e;
    text-decoration: none;
    white-space: nowrap; //needed to keep menu text from wrapping
  }

  .heading-hover:hover{
    text-shadow: 2px 2px 4px #656565;
    cursor: pointer;

  }



</style>


<script>
// @ is an alias to /src
import Section from '@/components/Section.vue';
import Contact from '@/components/ContactForm.vue';
import navBar from '@/components/navBar.vue';

import reflux from '@/components/content/condition-reflux.vue';
import colonCancer from '@/components/content/condition-cancer_colon.vue';
import constipation from '@/components/content/condition-constipation.vue';
import nausea from '@/components/content/condition-nausea.vue';
import rectalBleeding from '@/components/content/condition-rectal_bleeding.vue';




export default {
   name: 'home',
   components: {navBar, Section, reflux, colonCancer, constipation, nausea, rectalBleeding},
   data() {
      return {
         pages: [
            {title: 'Acid Reflux', link: '/conditions/reflux'},
            {title: 'Colorectal Cancer', link: '/conditions/colorectal-cancer'},
            {title: 'Constipation', link: '/conditions/constipation'},
            {title: 'Nausea/Vomiting', link: '/conditions/nausea-vomiting'},
            {title: 'Rectal Bleeding', link: '/conditions/rectal-bleeding'},
         ],
         page_index: 0,


      }
   },

   watch:{

      $route(to, from){
         this.set_page(to);
      }
   },

   methods: {
      highlight_class(i) {

         if (i === this.page_index)
            return 'heading-highlight';
         else
            return '';
      },

      set_page(procedure){
         switch (procedure){
            case 'reflux':
               this.page_index = 0;
               break;
            case 'colorectal-cancer':
               this.page_index = 1;
               break;

            case 'constipation':
               this.page_index = 2;
               break;

            case 'nausea-vomiting':
               this.page_index = 3;
               break;

            case 'rectal-bleeding':
               this.page_index = 4;
               break;

            default:
               this.page_index = 0;
               break;


         }
      },
   },

   computed: {
      /**
       * Sets settings for the subheadings
       *
       */
      menu_text(){
         if (['xs',].includes(this.$vuetify.breakpoint.name)) {
            return 'title';
         }
         else if (['md'].includes(this.$vuetify.breakpoint.name)) {
            return 'title';
         }
         else{
            return 'headline';
         }
      },

      heading_text(){
         if (['xs',].includes(this.$vuetify.breakpoint.name)) {
            return 'display-2';
         }
         else if (['md'].includes(this.$vuetify.breakpoint.name)) {
            return 'display-3';
         }
         else{
            return 'display-3';
         }
      },


   },
   created(){

      if (this.$route.params.condition !== undefined)
         this.set_page(this.$route.params.condition);
   }
}
</script>
